export enum PatientGoalTypeEnum {
    MEASUREMENT = 'MEASUREMENT',
    RECORD_BIOCHEMICAL = 'RECORD_BIOCHEMICAL'
}
